import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import BrandIdentity from '../components/BrandIdentity';
import PoemOfTheWeekHome from '../components/PoemOfTheWeekHome';
import CrisisTicker from '../components/CrisisTicker';
import CrisisStats from '../components/CrisisStats';
import Crisis from '../components/Crisis';
import GasolinePhilosophy from '../components/GasolinePhilosophy';
import GasolineWorkbookSeries from '../components/GasolineWorkbookSeries';
import SampleChapterCTA from '../components/SampleChapterCTA';
import InteractiveExercise from '../components/InteractiveExercise';
import ThreeTierProgram from '../components/ThreeTierProgram';
import Program from '../components/Program';
import CeremonySection from '../components/CeremonySection';
import UniqueFeatures from '../components/UniqueFeatures';
import MerchandiseStore from '../components/MerchandiseStore';
import AboutUsMedia from '../components/AboutUsMedia';
import PodcastImpact from '../components/PodcastImpact';
import PrayerRequestForm from '../components/PrayerRequestForm';
import Sponsorship from '../components/Sponsorship';
import SpotifySection from '../components/SpotifySection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <Hero />
      <BrandIdentity />
      <PoemOfTheWeekHome />
      <CrisisTicker />
      <CrisisStats />
      <Crisis />
      <GasolinePhilosophy />
      <GasolineWorkbookSeries />
      <SampleChapterCTA />
      <InteractiveExercise />
      <ThreeTierProgram />
      <Program />
      <CeremonySection />
      <UniqueFeatures />
      <MerchandiseStore />
      <AboutUsMedia />
      <PodcastImpact />
      <PrayerRequestForm />
      <Sponsorship />
      <SpotifySection />
      <Footer />
    </div>
  );
};

export default Home;
